var map = {
	"./archeology.svg": 681,
	"./beach.svg": 682,
	"./bike.svg": 683,
	"./brewery.svg": 684,
	"./bridge.svg": 685,
	"./building.svg": 686,
	"./bunker.svg": 687,
	"./cable_car.svg": 688,
	"./canyon.svg": 689,
	"./car_overlook.svg": 690,
	"./castle.svg": 691,
	"./cave.svg": 692,
	"./cementary.svg": 693,
	"./church.svg": 694,
	"./church_wood.svg": 695,
	"./city.svg": 696,
	"./cross.svg": 697,
	"./dam.svg": 698,
	"./horse.svg": 699,
	"./kayak.svg": 700,
	"./lake.svg": 701,
	"./lighthouse.svg": 702,
	"./marina.svg": 703,
	"./monument.svg": 704,
	"./mountain.svg": 705,
	"./museum.svg": 706,
	"./overlook.svg": 707,
	"./palace.svg": 708,
	"./park.svg": 709,
	"./quarry.svg": 710,
	"./ski.svg": 711,
	"./stones.svg": 712,
	"./swimming_pool.svg": 713,
	"./technical.svg": 714,
	"./theme_park.svg": 715,
	"./thermae.svg": 716,
	"./ticket.svg": 717,
	"./tower.svg": 718,
	"./train.svg": 719,
	"./trekking.svg": 720,
	"./tunnel.svg": 721,
	"./underground_path.svg": 722,
	"./urbex.svg": 723,
	"./village.svg": 724,
	"./waterfall.svg": 725,
	"./windmill.svg": 726,
	"./wine.svg": 727,
	"./zoo.svg": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;